module.exports = __webpack_public_path__ + "img/toi.ad84dc4b.svg";